<div class="fields">
    <app-form-input
        class="col-label"
        [control]="group().controls.label"
        [label]="'packages.pricing.tier.label' | translate"
        [inputId]="'tier-label-' + index()"
    />
    <app-form-number
        class="col-min"
        [control]="group().controls.minUsers"
        [label]="'packages.pricing.tier.minUsers' | translate"
        [min]="1"
        [inputId]="'tier-min-' + index()"
    />
    <app-form-number
        class="col-max"
        [control]="group().controls.maxUsers"
        [label]="'packages.pricing.tier.maxUsers' | translate"
        [placeholder]="'packages.pricing.tier.maxUsers.unlimited' | translate"
        [min]="1"
        [inputId]="'tier-max-' + index()"
    />
    <app-form-number
        class="col-price"
        [control]="group().controls.prices.controls[activeCurrency()]"
        [label]="('packages.pricing.tier.price' | translate) + ' (' + activeCurrency() + ')'"
        [min]="0"
        [minFractionDigits]="2"
        [maxFractionDigits]="2"
        [inputId]="'tier-price-' + index()"
    />
</div>

<p-button
    type="button"
    severity="secondary"
    icon="pi pi-trash"
    class="remove"
    [ariaLabel]="'packages.pricing.tier.remove' | translate"
    (onClick)="remove.emit()"
/>
